import type {
  ActionTypeEntity,
  CreateActionTypePayload,
  CreateActionTypeResponse,
  DeleteActionTypeResponse,
  UpdateActionTypePayload,
  UpdateActionTypeResponse,
} from '@/domains/actionType/actionType.entity';
import { ApiEndPoint } from '@/domains/api/api.entity';
import { apiRequest } from './apiRequest';

/**
 * Servicio HTTP para gestión de tipos de acciones académicas
 * Responsabilidad: Comunicación con endpoints de tipos de acciones
 */
class ActionTypeApiService {
  /**
   * Obtiene el catálogo completo de tipos de acciones disponibles
   */
  async getActionTypes(): Promise<ActionTypeEntity[]> {
    const response = await apiRequest.get<ActionTypeEntity[]>({
      route: ApiEndPoint.ACTION_TYPES,
    });

    return response;
  }

  /**
   * Crea un nuevo tipo de acción en el sistema
   * @param payload - Datos del nuevo tipo de acción (descripción, estado personal)
   */
  async createActionType(
    payload: CreateActionTypePayload,
  ): Promise<CreateActionTypeResponse> {
    const response = await apiRequest.post<
      CreateActionTypeResponse,
      CreateActionTypePayload
    >({
      route: ApiEndPoint.ACTION_TYPES,
      payload,
    });

    return response;
  }

  /**
   * Actualiza un tipo de acción existente
   * @param cod_tipo_accion - Código único del tipo de acción a actualizar
   * @param payload - Nuevos datos del tipo de acción
   */
  async updateActionType(
    cod_tipo_accion: number,
    payload: UpdateActionTypePayload,
  ): Promise<UpdateActionTypeResponse> {
    const response = await apiRequest.put<
      UpdateActionTypeResponse,
      UpdateActionTypePayload
    >({
      route: ApiEndPoint.ACTION_TYPES,
      param: `/${cod_tipo_accion}`,
      payload,
    });

    return response;
  }

  /**
   * Elimina un tipo de acción del sistema
   * @param cod_tipo_accion - Código único del tipo de acción a eliminar
   */
  async deleteActionType(
    cod_tipo_accion: number,
  ): Promise<DeleteActionTypeResponse> {
    const response = await apiRequest.delete<DeleteActionTypeResponse>({
      route: ApiEndPoint.ACTION_TYPES,
      param: `/${cod_tipo_accion}`,
    });

    return response;
  }
}

export const actionTypeApiService = new ActionTypeApiService();
